import React from 'react';

import { Button } from 'scouting-ui/lib';
import { useSlate } from 'slate-react';

import type { CustomEditor } from './EditorTextArea.types';
import { onPointerDown } from './EditorTextArea.utils';
import { getIcon } from './Icon';

const UndoButton = () => {
  const editor = useSlate();

  const onClick = () => {
    try {
      (editor as CustomEditor).undo?.();
    } catch {
      // ignore
    }
  };

  return (
    <Button
      data-test-id="block-button-undo"
      ghost
      icon={getIcon('undo')}
      onClick={onClick}
      onPointerDown={onPointerDown}
      size="small"
    />
  );
};

export default UndoButton;
